import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import {
  Children,
  type ReactElement,
  type ReactNode,
  isValidElement,
} from 'react';
import { SegmentButton } from './SegmentButton/SegmentButton';
import type { SegmentButtonProps } from './SegmentButton/SegmentButton.types';

function isSegmentButton(
  child: ReactNode,
): child is ReactElement<SegmentButtonProps> {
  return (
    isValidElement(child) && child.type === SegmentButton && child.props?.value
  );
}

export function getValidChildren(
  children: ReactNode,
): ReactElement<SegmentButtonProps>[] {
  const childrenArray = Children.toArray(children);
  const validChildren = childrenArray.filter(isSegmentButton);
  if (validChildren.length !== childrenArray.length) {
    stumble(
      'Some children of SegmentedButton component are not a SegmentButton and will be filtered out.',
    );
  }
  return validChildren;
}
